import React from 'react';
const immediateItems = [{
  emoji: '📅',
  text: 'Las 52 Clases del Año'
}, {
  emoji: '🤲',
  text: 'La Guía de Ajustes'
}, {
  emoji: '📱',
  text: '60 Captions de Instagram'
}, {
  emoji: '📓',
  text: 'El Tracker del Profesor'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        {/* Immediate Delivery */}
        <div className="text-center" data-id="element-34">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-10" data-id="element-35">
            📲 ¿Qué recibes inmediatamente?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-3xl mx-auto mb-12" data-id="element-36">
            {immediateItems.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl p-6 border border-border-light flex items-center gap-4 shadow-sm" data-id="element-37">
                <span className="text-3xl" data-id="element-38">{item.emoji}</span>
                <span className="text-text-main font-bold text-lg" data-id="element-39">
                  {item.text}
                </span>
              </div>)}
          </div>

          <p className="text-primary font-serif italic text-2xl sm:text-4xl font-bold" data-id="element-40">
            Cubres el material de todo el año
          </p>
        </div>
      </div>
    </section>;
}